import { useUndoRedo } from '@hooks/useUndoRedo'
import { useEffect } from 'react'

function isUndoRedoShortcut(event: KeyboardEvent): boolean {
  // Algunos eventos (IME, extensiones, autofill) llegan sin `key`.
  const key = typeof event.key === 'string' ? event.key.toLowerCase() : ''
  if (!key) return false

  const withMeta = event.metaKey || event.ctrlKey
  if (!withMeta) return false
  return key === 'z' || key === 'y'
}

export function useRollback() {
  const { performUndo, performRedo } = useUndoRedo()

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!isUndoRedoShortcut(event)) return

      const key = event.key.toLowerCase()
      if (key === 'z' && !event.shiftKey) {
        event.preventDefault()
        performUndo()
        return
      }

      if (key === 'y' || (key === 'z' && event.shiftKey)) {
        event.preventDefault()
        performRedo()
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [performUndo, performRedo])
}
